/**
 * 运营活动相关接口
 */

const activity = {
  /**
   * @module 速牛短信半流程
   */
  getSNHomePage: ['/lt-web/xs/smsHalf/getIndexHomePage'], // 获取速牛H5首页数据
  getSNComeObjectStatus: ['/lt-web/xs/smsHalf/applyStatus'], // 获取进件状态
  getSNMobileDecrypt: ['/lt-web/xs/smsHalf/decrypt'], // 手机号解密
  isLogin: ['/lt-web/xs/smsHalf/isLogin'] // 是否登录
}

export default activity
